import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateRiskConfig, UpdateRiskConfigBody } from "@/api/risk";
import { RiskQueryKeys } from "@/tanstackQuery/queries/risk";
import { RiskConfig } from "@/types/ApiResponses/Risk";

export interface UpdateRiskConfigOptions {
  onSuccess?: (data: RiskConfig, variables: UpdateRiskConfigBody) => void;
  onError?: (error: Error) => void;
}

// A threshold change alters which matches count as risky, so the list is
// refreshed together with the config.
export const useUpdateRiskConfig = (options?: UpdateRiskConfigOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateRiskConfigBody) => updateRiskConfig(body),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Config] });
      queryClient.invalidateQueries({ queryKey: [RiskQueryKeys.Matches] });
      options?.onSuccess?.(data, variables);
    },
    onError: options?.onError,
  });
};
